import { axiosInstance } from "../../../../../Services";

export const addCardMember = async (cardId, memberId) => {
    try {
      const res = await axiosInstance.put(
        `/mmhboard/cards/member/${cardId}/add`,
        { memberId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return res;
    } catch (error) {
      throw error;
    }
  };

  export const removeCardMember = async (cardId, memberId) => {
    try {
      const res = await axiosInstance.put(
        `/mmhboard/cards/member/${cardId}/remove`,
        { memberId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  
  export const fetchAdminsForMembers = async (showDownline = 0) => {
    try {
      const res = await axiosInstance.get(
        `/internal/user/admins?showDownline=${showDownline}`,
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  